<template>
  <div class="mechanism-container">
    <div class="mechanism-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/mechanism/index', query: { cid: fid } }">机构养老</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="mechanism-main">
          <div class="mechanism-head">
            <div class="mechanism-total">{{currentClassName.classname}}累计运营机构 <span>{{totals}}</span> 家</div>
            <div class="mechanism-select">
              <Select v-model="mechanismType" placeholder="请选择机构类型..." @on-change="changeType">
                <Option v-for="(item, index) in agency" :key="index" :value="item.datavalue">{{item.dataname}}</Option>
              </Select>
            </div>
          </div>
          <div class="mechanism-list">
            <div class="mechanism-li" v-for="item in list" :key="item.id">
              <router-link :to="{ path: '/mechanism/detail', query: { pid: pid, cid: item.classid, id: item.id } }" class="mechanism-li_">
                <div class="mechanism-li-img"><div :style="'backgroundImage:url(' + domainNameH5 + '/' + item.picurl + ')'"></div></div>
                <div class="mechanism-li-info">
                  <div class="mechanism-li-title">{{item.title}}</div>
                  <div class="mechanism-li-desc">{{item.description}}</div>
                  <div class="mechanism-li-btn"><div>了解详情</div></div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="list-page clear" v-if="totalsPage>1">
            <Page
              :current="page"
              :total="totals"
              @on-change="changePage"
              :page-size="6"
              prev-text="上一页"
              next-text="下一页"
            />
            <div class="list-page-total">共{{totalsPage}}页</div>
            <div class="list-page-jump">
              到第 <Input v-model="jumpPage" /> 页
            </div>
            <div class="list-page-btn" @click="jumpPageDeal">确定</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">{{fname.classname}}</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id" :class="[ item.id === cid ? 'active' : '']">
              <router-link :to="{ path: '/mechanism/index', query: { cid: item.id, pid: '' } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <apply-member></apply-member>
  </div>
</template>

<script>
import { validateInteger } from '../../assets/js/validate.js'
import { getHeaderData, getMechanismBasicData, getMechanismListData } from '../../api/getData.js'
import ApplyMember from '../../components/applyMember'
export default {
  name: 'mechanism',
  components: {
    ApplyMember
  },
  data () {
    return {
      headerInfo: {},
      fid: '',
      cid: '',
      pid: '',
      page: 1,
      mechanismType: '',
      jumpPage: '',
      totals: 0,
      totalsPage: 1,
      currentClassName: '',
      agency: [],
      fname: {},
      getsort: [],
      list: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.pid = this.$route.query.pid === undefined ? '' : this.$route.query.pid
      this.mechanismType = ''
      this.getHeaderInfo()
      this.getMechanismListInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.pid = this.$route.query.pid === undefined ? '' : this.$route.query.pid
    this.getMechanismBasicInfo()
    this.getMechanismListInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'mechanism', activeSendMenu: this.cid }).then(() => {}).catch(() => {})
    },
    async getMechanismBasicInfo () {
      let postData = {}
      if (this.pid !== '') {
        postData.pid = this.pid
      }
      if (this.cid !== '') {
        postData.cid = this.cid
      }
      let result = await getMechanismBasicData(postData)
      this.fid = result.fid
      this.cid = result.cid
      this.pid = result.pid
      this.fname = result.fname
      this.agency = result.agency
      this.getsort = result.city_list
      this.getHeaderInfo()
    },
    async getMechanismListInfo () {
      let postData = {}
      if (this.pid !== '') {
        postData.pid = this.pid
      }
      if (this.cid !== '') {
        postData.cid = this.cid
      }
      postData.p = this.page
      let result = await getMechanismListData(postData)
      this.totals = result.totalnum
      this.totalsPage = Math.ceil(result.totalnum / 6)
      this.currentClassName = result.cname
      this.list = result.agencylist
    },
    changeType () {
      this.page = 1
      this.pid = this.mechanismType
      this.getMechanismListInfo()
    },
    changePage (page) {
      this.page = page
      this.getMechanismListInfo()
    },
    jumpPageDeal () {
      if (!validateInteger(this.jumpPage)) {
        this.message('请输入正整数')
        return false
      }
      if (this.jumpPage > this.totalsPage) {
        this.message('页码不能大于' + this.totalsPage)
        return false
      }
      this.page = parseFloat(this.jumpPage)
      this.getMechanismListInfo()
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .inside-main{
    padding-bottom: 230px;
  }
  .mechanism-main{
    width: 77.22%;
    .mechanism-head{
      height: 110px;
      padding: 28px 17px 27px 50px;
      background-color: #ffffff;
      box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.22);
      border-radius: 6px;
      .mechanism-total{
        float: left;
        margin: 11px 0 10px;
        padding-left: 20px;
        border-left: 3px solid #ff4500;
        font-size: 24px;
        line-height: 34px;
        color: #666666;
        font-weight: bold;
        span{
          font-size: 36px;
          color: #ff4500;
        }
      }
      .mechanism-select{
        float: right;
        width: 380px;
        height: 55px;
        .ivu-select{
          font-size: 18px;
          color: #666666;
          .ivu-select-item{
            font-size: 18px !important;
            transition: all 0.5s ease 0s;
            color: #666666;
            &:hover {
              background: #eb6420;
              color: #ffffff;
            }
          }
          .ivu-select-item-focus{
            background: #eb6420;
            color: #ffffff;
          }
        }
      }
    }
    .mechanism-list{
      .mechanism-li{
        float: left;
        width: 50%;
        margin-top: 50px;
        padding-left: 50px;
        &:nth-child(1),&:nth-child(2){
          margin-top: 40px;
        }
        .mechanism-li_ {
          .mechanism-li-img {
            position: relative;
            padding-top: 75%;
            background-color: #ffffff;
            background-image: url("../../assets/images/pic04.png");
            background-position: center;
            background-repeat: no-repeat;
            overflow: hidden;
            div {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
              transition: all 0.5s ease 0s;
            }
          }
          .mechanism-li-info{
            padding: 32px 40px 30px 32px;
            background-color: #eeeeee;
            box-shadow: 0px 3px 6px 0px rgba(52, 47, 144, 0.2);
            .mechanism-li-title{
              height: 30px;
              font-size: 30px;
              line-height: 30px;
              color: #ec6420;
              font-weight: bold;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .mechanism-li-desc{
              height: 60px;
              margin-top: 20px;
              font-size: 22px;
              line-height: 30px;
              color: #666666;
              overflow: hidden;
            }
            .mechanism-li-btn{
              margin-top: 24px;
              overflow: hidden;
              div{
                float: right;
                width: 160px;
                height: 50px;
                border-radius: 25px;
                border: 1px solid #333333;
                font-size: 18px;
                line-height: 50px;
                text-align: center;
                color: #333333;
                transition: all 0.5s ease 0s;
              }
            }
          }
          &:hover{
            .mechanism-li-img{
              div{
                transform: scale(1.05);
              }
            }
            .mechanism-li-info{
              .mechanism-li-btn{
                div{
                  border: 1px solid #eb6420;
                  background-color: #eb6420;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1580px){
    .inside-main{
      padding-bottom: 195px;
    }
  }
  @media screen and (max-width: 1480px){
    .mechanism-main{
      .mechanism-list{
        .mechanism-li{
          padding-left: 25px;
          margin-top: 30px;
          &:nth-child(1),&:nth-child(2){
            margin-top: 30px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .inside-main{
      padding-bottom: 80px;
    }
    .mechanism-main{
      width: 100%;
      margin-bottom: 20px;
      .mechanism-head{
        height: auto;
        padding: 14px 9px 13px 25px;
        border-radius: 3px;
        .mechanism-total{
          float: none;
          margin: 5px 0;
          padding-left: 10px;
          border-left: 1.5px solid #ff4500;
          font-size: 12px;
          line-height: 17px;
          span{
            font-size: 18px;
          }
        }
        .mechanism-select{
          float: none;
          width: 190px;
          height: 28px;
          margin-top: 10px;
          .ivu-select{
            font-size: 12px;
            .ivu-select-item{
              font-size: 12px !important;
            }
          }
        }
      }
      .mechanism-list{
        .mechanism-li{
          float: none;
          width: 100%;
          margin-top: 25px;
          padding-left: 0;
          &:nth-child(1),&:nth-child(2){
            margin-top: 25px;
          }
          .mechanism-li_ {
            .mechanism-li-img{
              background-size: 100px auto;
            }
            .mechanism-li-info{
              padding: 16px 20px 15px 16px;
              .mechanism-li-title{
                font-size: 15px;
                line-height: 15px;
              }
              .mechanism-li-desc{
                height: auto;
                margin-top: 10px;
                font-size: 11px;
                line-height: 15px;
              }
              .mechanism-li-btn{
                margin-top: 12px;
                div{
                  width: 80px;
                  height: 25px;
                  border-radius: 12px;
                  font-size: 9px;
                  line-height: 25px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
<style lang="less">
  #app .mechanism-container .ivu-select-selection{
    height: 55px;
    margin-right: 0;
    border: 1px solid #434343;
    span{
      height: 55px;
      line-height: 55px;
    }
  }
  #app .mechanism-container .ivu-select-selection-focused, #app .mechanism-container .ivu-select-selection:hover{
    border-color: #eb6420;
  }
  #app .mechanism-container .ivu-select-visible .ivu-select-selection{
    box-shadow: 0 0 0 2px rgba(235,100,32,.2);
  }
  #app .mechanism-container .ivu-select-single .ivu-select-selection .ivu-select-placeholder, #app .mechanism-container .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
    font-size: 18px;
    color: #666666;
    padding-left: 22px;
    padding-right: 55px;
  }
  #app .mechanism-container .ivu-select-arrow{
    right: 18px;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background-color: #d9d9d9;
    line-height: 28px;
    text-align: center;
  }
  @media screen and (max-width: 1200px){
    #app .mechanism-container .ivu-select-selection{
      height: 28px;
      span{
        height: 28px;
        line-height: 28px;
      }
    }
    #app .mechanism-container .ivu-select-single .ivu-select-selection .ivu-select-placeholder, #app .mechanism-container .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
      font-size: 12px;
      padding-left: 11px;
      padding-right: 28px;
    }
    #app .mechanism-container .ivu-select-arrow{
      right: 12px;
      width: 14px;
      height: 14px;
      line-height: 14px;
    }
  }
</style>
